// removed by extract-text-webpack-plugin
module.exports = {"marketType":"_26HuvBUjyrxAzUzONObmoH","marketText":"_3f-VezaGlZJCgelFZC2xNf","customButtonContainer":"_1LU_akmBXujcndqEHqQG2Q","innerText":"_2645S0l2xW8Rki42cqZG50"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/matchday/css/oddsCard.css
// module id = 855
// module chunks = 0